import type { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import type { AttributeRow } from '@aytm/app/insights/dashboard/models/types.ClientDTO'

import { captionsFactory } from '@aytm/app/insights/dashboard/helpers/attributes'
import { getCurrentBlock, updateCurrentBlock } from '@aytm/app/insights/dashboard/helpers/requests'
import { processItems, updateHiddenItems } from '@aytm/app/insights/dashboard/helpers/items'

export type PresetChangePayload = {
  preset: string
  modifier: string
}

/**
 * Fires when user clicks on attribute
 * event.attribute field contains clicked attribute name
 */
export const presetChange = (
  state: InsightsDashboardPoolState,
  { preset, modifier }: PresetChangePayload
): InsightsDashboardPoolState => {
  let resultState = state
  const block = getCurrentBlock(state)
  const sortByAttribute = block.get<string>('sortByAttribute')
  const sections = block.getSections()
  const trackTarget = block.get<string>('trackTarget') || 'entity'
  const attributes = state.currentData?.attributes || {}
  const dataMetrics = state.currentData?.dataMetrics || {}
  const captions = captionsFactory({ attributes, dataMetrics, sections, trackTarget })({
    showSections: false,
    showMetrics: false,
    showMetadata: false,
    showCollapsed: true
  })
  const anyAttribute = (captions[0] as AttributeRow)?.attribute
  // Sort by attribute must be defined
  // If no current attribute then use first one from list
  const newAttribute = sortByAttribute || anyAttribute
  // Check if we need to hide blank columns
  const isDataOnly = 'data_only' === modifier && 'All' === preset
  // Update block model switching to default sort order
  resultState = updateCurrentBlock(resultState, { currentPreset: preset, hideBlankColumns: isDataOnly })
  // Process preset attributes
  const items = processItems(state, { preset, attribute: newAttribute })
  // Update model and data for new items
  resultState = updateCurrentBlock(resultState, { items })
  // Update hidden items array
  resultState = updateHiddenItems(resultState)
  return resultState
}
